module.exports = __webpack_public_path__ + "img/30_40.a82fa7b3.png";